var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowupRecipients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 3,
    fill: "#7043ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0967 5.64989C20.2649 5.79819 20.3364 6.02795 20.282 6.24553L17.082 19.0455C17.0296 19.2552 16.8684 19.4205 16.6601 19.4782C16.4518 19.5359 16.2285 19.4771 16.0757 19.3243L12.5649 15.8134L10.5799 18.46C10.446 18.6385 10.2241 18.728 10.0038 18.6922C9.78355 18.6565 9.60131 18.5014 9.53074 18.2897L8.00933 13.7255L5.03163 12.2367C4.81936 12.1305 4.6896 11.9092 4.7006 11.6722C4.7116 11.4351 4.8613 11.2268 5.08249 11.1408L19.4825 5.54081C19.6915 5.45952 19.9284 5.5016 20.0967 5.64989ZM12.9315 14.4831C12.9271 14.4785 12.9226 14.4739 12.9179 14.4695L12.5485 14.1L15.3242 11.3243C15.5585 11.09 15.5585 10.7101 15.3242 10.4757C15.0899 10.2414 14.71 10.2414 14.4757 10.4757L11.2757 13.6757C11.0414 13.91 11.0414 14.2899 11.2757 14.5243L11.7077 14.9563L10.307 16.8239L9.06916 13.1103C9.01884 12.9593 8.91061 12.8345 8.76828 12.7633L6.77887 11.7686L18.8366 7.07953L16.1749 17.7264L12.9315 14.4831Z",
    fill: "#7043ff",
    stroke: "#7043ff",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 19,
    height: 18,
    fill: "#7043ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7071 13.7071C21.0976 13.3166 21.0976 12.6834 20.7071 12.2929L14.3431 5.92893C13.9526 5.53841 13.3195 5.53841 12.9289 5.92893C12.5384 6.31946 12.5384 6.95262 12.9289 7.34315L18.5858 13L12.9289 18.6569C12.5384 19.0474 12.5384 19.6805 12.9289 20.0711C13.3195 20.4616 13.9526 20.4616 14.3431 20.0711L20.7071 13.7071ZM4 14L20 14V12L4 12L4 14Z",
    fill: "#f2f0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowupRecipients);
export default __webpack_public_path__ + "static/media/followup_recipients.6e578d38f72ecc04433d2f7728a6d2f0.svg";
export { ForwardRef as ReactComponent };